export const UNMATCHED_SIGNER_TRUST_SIGNAL = {
  None: 'None',
  TrustedSigner: 'TrustedSigner',
  TrustedPublisherName: 'TrustedPublisherName',
  TrustedIssuer: 'TrustedIssuer',
};

const UNMATCHED_SIGNER_TRUST_SIGNAL_MAPPING = [
  {
    value: UNMATCHED_SIGNER_TRUST_SIGNAL.TrustedSigner,
    label: 'Trusted Signer',
    color: '#7FBF86',
  },
  {
    value: UNMATCHED_SIGNER_TRUST_SIGNAL.TrustedPublisherName,
    label: 'Trusted Publisher Name',
    color: '#A5C9A8',
  },
  {
    value: UNMATCHED_SIGNER_TRUST_SIGNAL.TrustedIssuer,
    label: 'Trusted Issuer',
    color: '#7FB1D6',
  },
];

export const getUnmatchedSignerTrustSignal = value =>
  UNMATCHED_SIGNER_TRUST_SIGNAL_MAPPING.find(item => item.value === value) || null;
